const config = {
  zoom: 18,
  maxZoom: 27,
  minZoom: 14,
};
export default config;
